import { render, staticRenderFns } from "./CompanyResumCreate.vue?vue&type=template&id=6005344c"
import script from "./CompanyResumCreate.vue?vue&type=script&lang=js"
export * from "./CompanyResumCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports